<template>
  <components :is="currentView"></components>
</template>

<script>
  import Profile from './profile'
  import ProfileWJD from './profile-wjd'
  import ProfileZS from './profile-zs'
  import ProfileZH from './profile-zh'

  export default {
    data () {
      return {
        type: '3'
      }
    },
    computed: {
      currentView () {
        let view
        switch (this.type) {
          case '0':
            view = ProfileWJD
            break
          case '1':
            view = ProfileZS
            break
          case '2':
            view = ProfileZH
            break
          default:
            view = Profile
        }
        return view
      }
    },
    created () {
      this.type = this.$route.params.type
    }
  }
</script>



// WEBPACK FOOTER //
// profile-switch.vue?3ee3e33e